(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('CustomerSectorSearch', CustomerSectorSearch);

    CustomerSectorSearch.$inject = ['$resource'];

    function CustomerSectorSearch($resource) {
        var resourceUrl =  'api/_search/customer-sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
